import { NAV_HEIGHT_WITH_MARGIN } from './constants';

export function getScrollPositionFromElement(
  element: HTMLElement | null
): number {
  if (!element) {
    return 0;
  }

  const header = window.document.getElementsByTagName('header')[0];

  return (
    element.getBoundingClientRect().top +
    window.scrollY -
    NAV_HEIGHT_WITH_MARGIN -
    header.getBoundingClientRect().height
  );
}
